<template>
  <div>
    <van-image width="95%" height="auto" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/poster/chengguo3.jpeg" @click="previewImg(0)" />
    <van-image width="95%" height="auto" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/poster/chengguo2.jpeg" @click="previewImg(1)"/>
    <van-image width="95%" height="auto" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/poster/chengguo1.jpeg" @click="previewImg(2)"/>
  </div>
</template>


<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {}
  },
  methods: {
    previewImg(index) {
      ImagePreview({
        images: ['https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/poster/chengguo3.jpeg', 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/poster/chengguo2.jpeg', 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/poster/chengguo1.jpeg'],
        closeable: true,
        startPosition: index,
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>